import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "discounts-overview bg-white rounded" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center bg-light mb-3 p-2 rounded" }
const _hoisted_3 = { class: "d-flex align-items-center fs-3 m-0" }
const _hoisted_4 = { class: "mas mas-fill-1 me-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "mas ms-n1 me-1" }, "add", -1)
const _hoisted_6 = { class: "table table-hover align-middle" }
const _hoisted_7 = { class: "border-dark border-bottom pb-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", { class: "col-1" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "col-1"
}
const _hoisted_10 = {
  key: 1,
  class: "col-1"
}
const _hoisted_11 = { class: "col-1" }
const _hoisted_12 = { class: "col-1" }
const _hoisted_13 = { class: "col-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { class: "col-3" }, null, -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_DiscountsPriceListsOverviewItem = _resolveComponent("DiscountsPriceListsOverviewItem")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _createElementVNode("i", _hoisted_4, _toDisplayString(_ctx.isDiscount ? 'sell' : 'format_list_bulleted'), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.isDiscount ? _ctx.$t('discounts') : _ctx.$t('priceLists')), 1)
      ]),
      _createVNode(_component_router_link, {
        to: {name: _ctx.isDiscount ? 'new-discount' : 'new-price-list'},
        class: "btn btn-icon btn-primary d-flex align-items-center"
      }, {
        default: _withCtx(() => [
          _hoisted_5,
          _createTextVNode(_toDisplayString(_ctx.$t('new')), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("table", _hoisted_6, [
      _createElementVNode("thead", _hoisted_7, [
        _createElementVNode("tr", null, [
          _hoisted_8,
          _createElementVNode("th", {
            class: _normalizeClass(_ctx.isDiscount ? 'col-3' : 'col-5')
          }, _toDisplayString(_ctx.$t('name')), 3),
          (_ctx.isDiscount)
            ? (_openBlock(), _createElementBlock("th", _hoisted_9, _toDisplayString(_ctx.$t('type')), 1))
            : _createCommentVNode("", true),
          (_ctx.isDiscount)
            ? (_openBlock(), _createElementBlock("th", _hoisted_10, _toDisplayString(_ctx.$t('value')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('clientGroup')), 1),
          _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('from')), 1),
          _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('till')), 1),
          _hoisted_14
        ])
      ]),
      _createElementVNode("tbody", null, [
        (!_ctx.isReady)
          ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
              key: 0,
              "n-cols": _ctx.isDiscount ? 8 : 6
            }, null, 8, ["n-cols"]))
          : ((_ctx.isDiscount && !_ctx.hasDiscountSchemes) || (_ctx.isPriceList && !_ctx.hasPriceLists))
            ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                _createElementVNode("td", {
                  colspan: _ctx.isDiscount ? 8 : 6,
                  class: "fw-bold small text-uppercase text-muted"
                }, _toDisplayString(_ctx.$t('noContentFound')), 9, _hoisted_16)
              ]))
            : (_ctx.isDiscount)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.discountSchemes, (discountScheme) => {
                  return (_openBlock(), _createBlock(_component_DiscountsPriceListsOverviewItem, {
                    key: discountScheme.id,
                    data: discountScheme,
                    type: "DISCOUNT",
                    onMoveScheme: _ctx.moveScheme,
                    onDeleteScheme: _ctx.deleteScheme
                  }, null, 8, ["data", "onMoveScheme", "onDeleteScheme"]))
                }), 128))
              : (_ctx.isPriceList)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.priceLists, (priceList) => {
                    return (_openBlock(), _createBlock(_component_DiscountsPriceListsOverviewItem, {
                      key: priceList.id,
                      data: priceList,
                      type: "PRICELIST",
                      onMoveScheme: _ctx.moveScheme,
                      onDeleteScheme: _ctx.deleteScheme
                    }, null, 8, ["data", "onMoveScheme", "onDeleteScheme"]))
                  }), 128))
                : _createCommentVNode("", true)
      ])
    ])
  ]))
}